var React = require('react');

function Cuadro (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Trazado_5","data-name":"Trazado 5","d":"M3274.551,1507l493.672.184,97.548,89.59V1929.7H3039.814V1507Z","transform":"translate(-3039.314 -1506.5)","fill":"none","stroke":"#fff","strokeWidth":"1"}));
}

Cuadro.defaultProps = {"width":"826.957","height":"423.698","viewBox":"0 0 826.957 423.698"};

module.exports = Cuadro;

Cuadro.default = Cuadro;
